import React, {useState} from "react";

import GettingStartedContext from "./GettingStartedContext";
import { Tooltip } from 'react-tooltip'

const ProviderWrap = ({children, lang, link, paramId}) => {

  const [data, setData] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [result, setResult] = useState(null);
  const [planes, setPlanes] = useState([]);
  const [plans, setPlans] = useState([]);
  const [plan, setPlan] = useState(null);
  const [ownerships, setOwnerships] = useState([]);
  const [location, setLocation] = useState(null);
  const [hours, setHours] = useState(null);
  const [plane, setPlane] = useState(null);
  const [ownership, setOwnership] = useState(null);
  const [showSkip, setShowSkip] = useState(false);
  const [question, setQuestion] = useState(null);
  const [showDownloadPricing, setShowDownloadPricing] = useState(false);
  const [submittedQuestions, setSubmittedQuestions] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [reloadResults, setReloadResults] = useState(false);
  const [staticBlock, setStaticBlock] = useState(false);

  const langString = (id, fallback, defaultVal) => {
    if (data && data.Strings) {
      if (typeof data.Strings[id] !== 'undefined') {
        return data.Strings[id];
      }
      if (fallback && typeof data.Strings[fallback] !== 'undefined') {
        return data.Strings[fallback];
      }
    }
    return defaultVal ? defaultVal : '';
  }

  const getProperty = (object, property, fallback) => {
    if (typeof object[property] !== 'undefined') {
      return object[property];
    }
    if (fallback && typeof object[fallback] !== 'undefined') {
      return object[fallback];
    }
    return '';
  }

  const getLink = (action) => {
    let url = link;

    if(link.charAt(link.length - 1) !== '/'){
      url += '/';
    }
    
    if (action) {
      url += action;
    }
    if (paramId && lang) {
      url += '?block=' + paramId + '&lang=' + lang
    }
    return url;
  }

  const isFr = () => {
    return lang === 'fr_CA';
    console.log('lang is' + lang); // ✅ [ ] Test - evaluates to correct langcode
  }

  const isEn = () => {
    return lang !== 'fr_CA';
    console.log('lang is' + lang); // ✅ [ ] Test - evaluates to correct langcode
  }

  const formatNumber = (val) => {
    let number = parseFloat(val);
    // return isFr() ? number : number.toLocaleString(isFr() ? 'fr-FR' : 'en-US'); // [ ] Broken Original
      // ///
      //   return isFr() ? // [ ] Reformatted Original 
      //     (number) :  // Currently if FR is active - this is just using the english number
      //     (number.toLocaleString(isFr() ? 
      //       ('fr-FR') : 
      //       ('en-US'))); // [ ] 
      // ///

    return isFr() ? number.toLocaleString('fr-CA') : number.toLocaleString('en-US');
    
  }

  const requestVariable = (name) => {
    let result = null,
      tmp = [];
    window.location.search
      .substring(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === name) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }

  const selectTestimonials = () => {
    let list = []
    if (question
      && question.ShowTestimonial
      && question.Option && question.Option.Testimonials) {
      list = question.Option.Testimonials;
    }
    if (list.length === 0) {
      const prev = previousSubmittedQuestion(question);
      if (prev && prev.ShowTestimonial && prev.Option) {
        list = prev.Option.Testimonials;
      }
    }
    setTestimonials(list);
  }

  const indexOfSubmittedQuestion = (q) => {
    return submittedQuestions.findIndex(qq => qq.Pos === q.Pos);
  }

  const previousSubmittedQuestion = (q) => {
    const index = indexOfSubmittedQuestion(q);
    return typeof submittedQuestions[index - 1] !== 'undefined' ? submittedQuestions[index - 1] : null;
  }

  const padLeadingZeros = (num, size) => {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  const getNextQuestion = (q) => {
    const currentQuestion = q ? q : question;
    for (const qq of data.Questions) {
      if (!currentQuestion) {
        return qq;
      }
      if (qq.Pos > currentQuestion.Pos) {
        return qq;
      }
    }
    return null;
  }
  const scrollTo = (id) => {
    const elm = document.getElementById(id);
    if (elm) {

      const headerOffset = 45;
      const elementPosition = elm.getBoundingClientRect().top;
      let offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }

  const showToolTip = (text) => {
    const content = langString(text);
    return <>
      <span
        className="gsa__tooltip"
        data-tooltip-id="tool-tip"
        data-tooltip-content={content}
        data-tooltip-variant="light"
      >
        ?
      </span>
    </>;
  }

  const showWarningToolTip = (text) => {
    const content = langString(text);
    return <>
      <span
        className="gsa__tooltip gsa__tooltip--white"
        data-tooltip-id="tool-tip"
        data-tooltip-content={content}
        data-tooltip-variant="light"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="15.728" height="15.728" viewBox="0 0 15.728 15.728">
          <path d="M8.518.654a7.864,7.864,0,1,0,7.864,7.864A7.864,7.864,0,0,0,8.518.654Zm.333,3.111A1.034,1.034,0,1,1,7.817,4.8,1.034,1.034,0,0,1,8.851,3.765Zm.927,9.147a1.737,1.737,0,0,1-1.84.168,1.327,1.327,0,0,1-.543-.529,2.031,2.031,0,0,1-.214-1.277l.1-.811.266-2.114-.724.016A.613.613,0,0,1,6.586,7.18l1.856-.731a.859.859,0,0,1,1.114.485.848.848,0,0,1,.038.506l-.025.11-.726,3.187-.181.8a1.748,1.748,0,0,0-.038.21c-.02.359.491.09.491.09a.633.633,0,0,1,.663,1.077Z" transform="translate(-0.654 -0.654)" fill="#5ac3ff"/>
        </svg>
      </span>
    </>;
  }

  const showFooter = () => {
    const dom = document.getElementById('result-page-footer');
    if (dom) {
      dom.style.display = 'block';
    }
  }

  const hideFooter = () => {
    const dom = document.getElementById('result-page-footer');
    if (dom) {
      dom.style.display = 'none';
    }
  }


  return <GettingStartedContext.Provider value={{
    lang: lang,
    link: link,
    data: data,
    reloadResults: reloadResults,
    setReloadResults: setReloadResults,

    setData: setData,
    showResult: showResult,
    setShowResult: setShowResult,
    result: result,
    setResult: setResult,
    planes: planes,
    setPlanes: setPlanes,
    plans: plans,
    setPlans: setPlans,
    plan: plan,
    setPlan: setPlan,
    ownerships: ownerships,
    setOwnerships: setOwnerships,
    location: location,
    setLocation: setLocation,
    hours: hours,
    setHours: setHours,
    plane: plane,
    setPlane: setPlane,
    ownership: ownership,
    setOwnership: setOwnership,
    showSkip: showSkip,
    setShowSkip: setShowSkip,
    showDownloadPricing: showDownloadPricing,
    setShowDownloadPricing: setShowDownloadPricing,
    question: question,
    setQuestion: setQuestion,
    testimonials: testimonials,
    setTestimonials: setTestimonials,
    staticBlock:staticBlock,
    setStaticBlock:setStaticBlock,

    submittedQuestions: submittedQuestions,
    setSubmittedQuestions: setSubmittedQuestions,
    selectTestimonials: selectTestimonials,
    indexOfSubmittedQuestion: indexOfSubmittedQuestion,
    getNextQuestion: getNextQuestion,

    langString: langString,
    getLink: getLink,
    isFr: isFr,
    isEn: isEn,
    formatNumber: formatNumber,
    getProperty: getProperty,
    requestVariable: requestVariable,
    padLeadingZeros: padLeadingZeros,
    scrollTo: scrollTo,
    showToolTip: showToolTip,
    showWarningToolTip: showWarningToolTip,

    showFooter: showFooter,
    hideFooter: hideFooter
  }}>
    {children}
    <Tooltip id={'tool-tip'} />
  </GettingStartedContext.Provider>;
}

export default ProviderWrap;
